import { config } from '@config/config'
import { ROUTES } from '@constants/index'
import { DefaultViewType } from '@typesApp/ViewNavigation'

const toRoutePath = (pageRoute: DefaultViewType | undefined): string | undefined => {
  if (!pageRoute) return undefined
  return pageRoute === 'intro' ? ROUTES.BASE : pageRoute
}

export const getDefaultView = (fallbackView?: string): string => {
  const defaultView = config.getFeatures()?.defaultView
  return toRoutePath(defaultView) ?? fallbackView ?? ROUTES.BASE
}
